import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/programa-de-detección-de-señales")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/programa-de-detección-de-señales", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia", replace: true });
  },
});
